import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { UserAvatarComponent } from '@ninety/mobile/platform/components';
import { UserNameOptions, UserNamePipe } from '@ninety/mobile/platform/services';

import { DiscussionListItem } from '../../models/discussion.models';
import { UserInitialsPipe } from '../../pipes/user-initials.pipe';

export type ParticipantStatus = 'complete' | 'incomplete';

@Component({
  selector: 'nty-discussion-list-item-participant',
  imports: [UserAvatarComponent, UserNamePipe, UserInitialsPipe],
  template: `
    <nty-user-avatar
      size="24px"
      fontSize="10px"
      [userInitials]="discussion[mode] | userName | userInitials"
      [avatarUrl]="avatarUrl" />

    <span class="user-name terra-body">
      {{ discussion[mode] | userName: userNamePipeOptions }}
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      @use 'terra';

      :host {
        display: flex;
        align-items: center;
        gap: 6px;
      }

      .user-name {
        display: inline-block;
        max-width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: terra.color(text);
      }
    `,
  ],
})
export class DiscussionListItemParticipantComponent {
  @Input({ required: true }) discussion!: DiscussionListItem;
  @Input() mode: keyof Pick<DiscussionListItem, 'manager' | 'managee'> = 'manager';

  userNamePipeOptions: UserNameOptions = { withLastInitial: true };

  get avatarUrl() {
    return this.discussion[this.mode]?.metadata?.picture?.url ?? '';
  }

  get isComplete() {
    return this.mode === 'manager' ? this.discussion.isManagerDone : this.discussion.isManageeDone;
  }
}
